import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@shared/services/auth.service';
import { ConfirmationDialogComponent } from '@shared/confirmation-dialog/confirmation-dialog.component';
import { LocaleService } from '@shared/services/locale.service';
import { User } from '@core/models';

@Component({
	selector: 'app-transfer-complete-dialog',
	templateUrl: './transfer-complete-dialog.component.html',
	styleUrls: ['./transfer-complete-dialog.component.scss'],
})
export class TransferCompleteDialogComponent implements OnInit {
	constructor(private auth: AuthService, public locale: LocaleService, public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {}

	embedded: boolean = false;
	errorScreen: boolean = false;
	adID: string;
	tokenID: any;
	user: User = this.auth.user();
	loading: boolean = false;

	onYes() {
		this.dialogRef.close(true);
	}

	onNo() {
		this.dialogRef.close(false);
	}

	ngOnInit(): void {}
}
